<template>
  <div class="worksheetdetail-container"
       v-if="revokeVisible ||verifyVisible1 || verifyVisible2 ||closeVisible">
    <!-- 撤销 -->
    <el-dialog :title="$t('text.revoke')"
               :visible.sync="revokeVisible"
               size="tiny"
               :close-on-click-modal="false"
               :before-close="handleCancelRevoke">
      <h2 class="jc-h2">{{$t('speechcraft.revokeTitle')}}</h2>
      <el-input type="textarea"
                style="margin-top:20px;"
                :autosize="{ minRows: 4, maxRows: 6}"
                v-model="revokeReason"
                :maxlength="256"
                :minlength="0"
                resize="none"
                radial-counter
                :placeholder="$t('placeholder.revoke')"></el-input>
      <!-- <div class="remark-tips">{{$t('merge.wordCount',[revokeReason.length])}}</div> -->
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCancelRevoke">{{$t('text.cancel')}}</el-button>
        <el-button type="primary"
                   @click="handleConfirm('revoke')"
                   :disabled="(revokeReason.trim() === '' || disable)">{{$t('text.confirm')}}</el-button>
      </div>
    </el-dialog>

    <!-- 核验方案 -->
    <el-dialog :title="$t('text.verify')"
               :visible.sync="verifyVisible1"
               size="tiny"
               :close-on-click-modal="false"
               :before-close="handleCancelVerify1">
      <div class="jc-h2-content">
        <div style="margin: 0px 0px 20px 0;line-height: 24px;">{{$t('speechcraft.verifyPlan')}}</div>
        <div>
          <el-radio size="mini"
                    class="radio"
                    v-model="currentOperation"
                    label='false'>{{$t('text.pass')}}</el-radio>
          <el-radio size="mini"
                    class="radio"
                    v-model="currentOperation"
                    label='refuse'>{{$t('text.reject')}}</el-radio>
          <el-input v-if="currentOperation == 'refuse'"
                    type="textarea"
                    style="margin-top:10px;"
                    :autosize="{ minRows: 4, maxRows: 6}"
                    v-model="revokeReason"
                    :maxlength="256"
                    :placeholder="$t('placeholder.verifyPlan')"></el-input>
          <div v-if="currentOperation == 'refuse'"
               class="remark-tips">{{revokeReason.length}}/256字</div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleCancelVerify1">{{$t('text.cancel')}}</el-button>
        <el-button type="primary"
                   @click="handleConfirm('verify1')"
                   :disabled="(currentOperation === 'true' || (revokeReason.trim() === '' && currentOperation != 'false')) || disable">{{$t('text.confirm')}}</el-button>
      </span>
    </el-dialog>

    <!-- 核验交付 -->
    <el-dialog :title="$t('text.verify')"
               :visible.sync="verifyVisible2"
               size="tiny"
               :close-on-click-modal="false"
               :before-close="handleCancelVerify2">
      <div class="jc-h2-content">
        <div style="margin: 0px 0px 20px 0;line-height: 24px;">{{$t('speechcraft.verifyPay')}}</div>
        <el-form class="dailog-form">
          <el-form-item :label="$t('text.enclosure')+'：'">
            <el-upload class="upload-demo"
                       accept=".jpg,.png,.pdf"
                       :limit="2"
                       name="upFile"
                       :before-upload="beforeAvatarUpload"
                       :on-exceed="handleExceed"
                       action="/ccs-api/api/ticket/importToOssByName"
                       :data="formData"
                       :on-remove="handleRemove"
                       :on-success="success">
              <el-button size="small"
                         icon="upload2">{{$t('ticket.upLoadFile')}}</el-button>
              <div slot="tip"
                   class="jc-upload__tip">{{$t('placeholder.verifyUploadTip')}}</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div style="margin-top:10px;">
          <el-radio class="radio"
                    v-model="currentOperation"
                    label='false'>{{$t('speechcraft.iAgree')}}</el-radio>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleCancelVerify2">{{$t('text.cancel')}}</el-button>
        <el-button type="primary"
                   @click="handleConfirm('verify2')"
                   :disabled="(!(currentOperation === 'false' && fileList.length != 0)) || disable">{{$t('text.confirm')}}</el-button>
      </span>
    </el-dialog>

    <!-- 关单 -->
    <el-dialog class="close"
               :title="$t('text.closeTicket')"
               :visible.sync="closeVisible"
               size="tiny"
               :close-on-click-modal="false"
               :before-close="handleCancelClose">
      <div class="jc-h2-content">
        <div style="margin: 0px 0px 20px 0;line-height: 24px;">{{$t('speechcraft.closeTickekTitle')}}</div>
        <div>
          <el-radio class="radio"
                    v-model="currentOperation"
                    label='false'>{{$t('speechcraft.iAgree')}}</el-radio>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleCancelClose">{{$t('text.cancel')}}</el-button>
        <el-button type="primary"
                   @click="handleConfirm('close')"
                   :disabled="(currentOperation === 'true' || disable)">{{$t('text.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  components: {},

  props: {
    currentDailog: {
      default: '',
      type: String
    },
    currentTicketNo: {
      default: null,
      type: String
    },
    currentTaskNodeId: {
      default: '',
      type: String
    }
  },

  data () {
    return {
      revokeVisible: false, // 撤销弹框
      verifyVisible1: false, // 核验方案弹框
      verifyVisible2: false, // 核验交付弹框
      closeVisible: false, // 关单弹框
      revokeReason: '',
      ticketNo: null,
      currentOperation: null,
      disable: false, // 防止多次提交
      formData: {
        fileName: ''
      },
      fileList: [],
      attachList: [], // 上传文件文件返回地址
      currentTaskNode: ''
    };
  },

  created () {
    this.ticketNo = this.$route.query.ticketNo;
  },

  mounted () { },

  watch: {
    currentDailog (newValue, oldValue) {
      if (newValue == 'close') {
        this.currentOperation = 'true';
        this.closeVisible = true;
      } else if (newValue == 'revoke') {
        this.revokeVisible = true;
      } else if (newValue == 'verify1') {
        this.currentOperation = 'true';
        this.verifyVisible1 = true;
      } else if (newValue == 'verify2') {
        this.currentOperation = 'true';
        this.verifyVisible2 = true;
      } else return false;
    },

    currentTicketNo (newValue, oldValue) {
      this.ticketNo = newValue;
    },

    currentTaskNodeId (newValue, oldValue) {
      this.currentTaskNode = newValue;
    }
  },

  computed: {},

  methods: {
    handleCancelClose () {
      // 关闭工单
      this.$emit('update:currentTicketNo', null);
      this.$emit('update:currentDailog', '');
      this.$emit('update:currentTaskNodeId', '');
      this.closeVisible = false;
      this.currentOperation = null;
    },

    handleCancelRevoke () {
      // 撤销工单
      this.$emit('update:currentTicketNo', null);
      this.$emit('update:currentDailog', '');
      this.$emit('update:currentTaskNodeId', '');
      this.revokeVisible = false;
      this.revokeReason = '';
    },

    handleCancelVerify1 () {
      // 核验方案
      this.$emit('update:currentTicketNo', null);
      this.$emit('update:currentDailog', '');
      this.$emit('update:currentTaskNodeId', '');
      this.verifyVisible1 = false;
      this.revokeReason = '';
    },

    handleCancelVerify2 () {
      // 核验交付
      this.$emit('update:currentTicketNo', null);
      this.$emit('update:currentDailog', '');
      this.$emit('update:currentTaskNodeId', '');
      this.verifyVisible2 = false;
      this.currentOperation = null;
      this.fileList = [];
      this.attachList = [];
    },

    // 工单操作
    handleConfirm (type) {
      if (type === 'revoke') { // 撤销工单
        this.disable = true;
        const params = {
          ticketNo: this.ticketNo,
          remarks: this.revokeReason
        };
        this.$api.cancelWorksheet(params).then((temp) => {
          if (temp.errno === 10000 && temp.errmsg === 'OK') {
            if (temp.data.success) {
              this.revokeVisible = false;
              this.revokeReason = '';
              this.$emit('updateList');
              this.$emit('update:currentDailog', '');
            }
          }
        }).catch(() => {
          this.$message.error(this.$t('ticket.handleWorksheetError'));
        }).finally(() => {
          this.disable = false;
        });
      } else if (type == 'verify1') {
        // 方案核验确认
        this.disable = true;
        var self = this;
        var params = {};
        if (this.currentOperation === 'false') {
          params = {
            ticketNo: this.ticketNo,
            action: 'agree'
          };
        } else if (this.currentOperation === 'refuse') {
          params = {
            ticketNo: this.ticketNo,
            action: 'reject',
            remarks: this.revokeReason
          };
        }
        params = Object.assign(params, { currentTaskNodeId: this.currentTaskNode });
        this.$api.planWorksheet(params).then((temp) => {
          if (temp.errno === 10000 && temp.errmsg === 'OK') {
            if (temp.data.execRes) {
              self.verifyVisible1 = false;
              setTimeout(() => { this.disable = false; }, 1000);
              self.currentOperation = null;
              self.$emit('updateList');
              self.$emit('update:currentDailog', '');
              self.fileList = [];
              self.attachList = [];
            }
          }
        }).catch(() => {
          this.$message.error(this.$t('ticket.handleWorksheetError'));
        }).finally(() => {
          this.disable = false;
        });
      } else if (type == 'verify2') {
        // 方案交付确认
        this.disable = true;
        var self = this;
        var params = {
          ticketNo: this.ticketNo,
          attach: []
        };
        for (const key in this.attachList) {
          delete this.attachList[key].uid;
        }
        params = Object.assign(params, { currentTaskNodeId: this.currentTaskNode });
        params.attach = this.attachList;
        this.$api.planedWorksheet(params).then((temp) => {
          // var temp = JSON.parse(res);
          if (temp.errno === 10000 && temp.errmsg === 'OK') {
            if (temp.data.execRes) {
              self.verifyVisible2 = false;
              setTimeout(() => { this.disable = false; }, 1000);
              self.currentOperation = null;
              self.$emit('updateList');
              self.$emit('update:currentDailog', '');
            }
          }
        }).catch(() => {
          this.$message.error(this.$t('ticket.handleWorksheetError'));
        }).finally(() => {
          this.disable = false;
        });
      } else if (type == 'close') {
        // 确认关单
        this.disable = true;
        var self = this;
        var params = {
          ticketNo: this.ticketNo
        };
        params = Object.assign(params, { currentTaskNodeId: this.currentTaskNode });
        this.$api.closeWorksheet(params).then((temp) => {
          if (temp.errno === 10000 && temp.errmsg === 'OK') {
            if (temp.data.execRes) {
              self.closeVisible = false;
              setTimeout(() => { this.disable = false; }, 1000);
              self.currentOperation = null;
              self.$emit('updateList');
              self.$emit('update:currentDailog', '');
            }
          }
        }).catch(() => {
          this.$message.error(this.$t('ticket.handleWorksheetError'));
        }).finally(() => {
          this.disable = false;
        });
      }
    },

    beforeAvatarUpload (file) {
      this.formData.fileName = file.name;
      let isIMAGE = false;
      const name = file.name.substring(file.name.lastIndexOf('.') + 1);
      const arr = ['jpg', 'png', 'pdf'];
      if (arr.indexOf(name) > -1) {
        isIMAGE = true;
      }
      const isLt1M = file.size / 1024 / 1024 / 5 <= 1;
      if (!isIMAGE) {
        this.$message.error(this.$t('merge.uploadShouldBe1'));
      }
      if (!isLt1M) {
        this.$message.error(this.$t('merge.uploadMax5M'));
      }
      return isIMAGE && isLt1M;
    },

    handleExceed () {
      this.$message.warning(this.$t('merge.uploadShouldBeTwo'));
    },

    success (response, file, fileList) {
      this.$message.success(this.$t('ticket.uploadFileSuccess'));
      this.fileList = fileList;
      this.attachList.push({
        uid: file.uid,
        attachName: response.data.fileName,
        attachPath: response.data.ossUrl
      });
    },

    handleChangeUp (file) {
      if (file.status == 'ready') {
        this.formData = {
          fileName: this.$t('ticket.constructioDelivery')
        };
      }
    },

    handleRemove (file, fileList) {
      for (let i = 0; i < this.attachList.length; i++) {
        if (this.attachList[i].uid === file.uid) {
          this.attachList.splice(i, 1);
          break;
        }
      }
      this.fileList = fileList;
    },
  }
};
</script>
<style lang="scss">
@import "./scss/WorksheetDetail";
.close {
  .jc-dialog__body {
    padding: 30px 10px 30px 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/WorksheetAction.vue